import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Slide from '@mui/material/Slide';
import moment from "moment"
import { STATUS_CONFIG } from '../../../constants';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const History = ({historyData}) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const getStatusColor = (status) => {
    return status === 'success' ? 'green' : 'red';
  };

  return (
    <React.Fragment className="">
      <Button className='history_content_btn' variant="outlined" onClick={handleClickOpen}>
        <AccessTimeIcon/>
        <span>History</span>
      </Button>
      <Dialog
       open={open}
       TransitionComponent={Transition}
       keepMounted
       aria-describedby="alert-dialog-slide-description"
       className=''
       PaperProps={{
         style: {
           width: '800px',
           maxWidth: '800px' ,
           borderRadius: '10px'
         },
       }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='d-flex align-items-center '>
          <AccessTimeIcon/>
          History
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
         <DialogContent className='p-4'>
            {historyData && historyData.length > 0 && historyData.map((item, index) => (
                <Typography key={index} sx={{ mb: 1 }}>
                    <strong>Date Time:</strong>  {moment(item.created_at).format("MM/DD/YYYY @ hh:mma")},{' '}
                    <strong>Memory:</strong> {'6.00 MB'},{' '}
                    <strong>Status:</strong>{' '}
                    <span className='text-capitalize' style={{ color: STATUS_CONFIG[item.status].color }}>
                    {item.status}
                    </span>
                    , <strong>Result:</strong> Tests: {item.total_test_case}, Success: {item.passed_test_case}, Failures: {item.failed_test_case}
                </Typography>
            ))}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

export default History;